<template>
    <a class="quiz__campaign-answer" @click="onAnswerSelection" :class="{ 'quiz__campaign-answer-with-image': show_image, 'quiz__campaign-answer-with-icon': answer.is_icon, 'quiz__campaign-answer-active' : is_active, 'quiz__campaign-answer-greyed' : is_greyed  }">
        <div v-if="show_image">
            <div v-if="answer.is_icon" :class="'quiz__campaign-answer-icon'">
                <img :src="answer.image_url" :alt="answer.content"  />
            </div>
            <div v-else class="quiz__campaign-answer-image" :style="background_image" >
            </div>
        </div>
        <span class="quiz__campaign-answer-text">{{ answer.content }}</span>
    </a>
</template>
<script>

export default {
    props: ['question', 'answer','answer_given','answertype', 'question_number'],
    methods: {
        onAnswerSelection(){
            Event.$emit('question_'+ this.question.id +'_answered', { active_id: this.answer.id, answer_content: this.answer.content, question_id : this.question.id  });
            Event.$emit('page_answer_given', { question_id: this.question.id, question_type: this.question.quiz_campaign_question_type_id, answer_id: this.answer.id, answer_text: this.answer.content, include_in_dynamic_title: this.question.include_in_endpoint });
        }
    },
    mounted() {
        this.background_image = (this.answer.image_url!==null) ? 'background-image: url("'+ this.answer.image_url + '"); ' : '';
        this.show_image = ( this.answertype != 1 );
    },
    created() {
        Event.$on('question_'+ this.question.id +'_answered', ( $event ) => ( this.is_active = ($event.active_id == this.answer.id ) ? true : false ) );
        Event.$on('question_'+ this.question.id +'_answered', ( $event ) => ( this.is_greyed = ($event.active_id == this.answer.id ) ? false : true ) );
    },
    data() {
        return {
            background_image : null,
            is_active: false,
            is_greyed: false,
            show_image: false
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/quiz-campaign/components/answer.vue